import { init } from 'cse-chatbot';
import type { DecagonInstance } from 'cse-chatbot/dist/types/types';

import { SOURCE } from 'constants/general';

import { isProd } from 'helpers/utils';

export function createDecagonClient() {
    let instance: DecagonInstance | null = null;

    const initialize = async (authToken: string): Promise<void> => {
        const { decagon } = await init({
            env: isProd() ? 'prod' : 'stage',
            projectId: 'yoga',
            companyName: 'welltech',
            authToken,
            extraMetaData: {
                source: SOURCE,
            },
        });

        instance = decagon;
    };

    const open = (): void => instance?.open();

    const close = (): void => {
        if (!instance) return;

        const current = instance;

        instance = null;

        current.close();
        current.hide();
    };

    return {
        initialize,
        open,
        close,
    };
}

export const decagonClient = createDecagonClient();
